import { Application } from 'api';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { LTHeader, LTItem, LTPlaceholder, LTMobileItem } from 'components/common/ListTable';
import { CustomLTRow } from '../../customLTRow/customLTRow';
import * as S from '../../Table.styled';
import { useTranslation } from 'react-i18next';
import { convertToCurrencySymbol } from 'utils/convertToCurrencySymbol';

function VisaOffersB2B() {
    const navigate = useNavigate();
    const { applications: clientApps } = useSelector((state: RootState) => state.applications);
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);

    const linkToAgreement = (appId: number) => {
        const currentPathArray = window.location.pathname.split('/');
        currentPathArray[currentPathArray.length - 2] = appId.toString();
        currentPathArray[currentPathArray.length - 1] = 'agreement';
        const newPath = currentPathArray.join('/');
        navigate(newPath, { replace: true });
    };

    // const getInitialTime = (date: Date | null) => {
    //     if (date) {
    //         return new Date(date).getTime();
    //     }
    //     return 0;
    // };

    // const getDeadline = (initialDate: Date | null) => {
    //     const sixDays = 6 * 24 * 60 * 60 * 1000;
    //     const startTime = getInitialTime(initialDate);

    //     const deadline = startTime + sixDays;
    //     return deadline;
    // };

    const { t } = useTranslation();
    const appsWithOffers = clientApps.filter((app) => app.date_offer_sent);
    return (
        <S.ListTable>
            <LTHeader>
                {/* tooltips are present in LTItem itself */}
                <LTItem maxWidth="40%" minWidth="40%">
                    {t('visaName', { lng: language })}
                </LTItem>

                <LTItem maxWidth="60px" minWidth="60px" style={{ textAlign: 'center' }}>
                    {t('amount', { lng: language })}
                </LTItem>
                {/* <LTItem maxWidth="100px" minWidth="100px" style={{ textAlign: 'center' }}>
                    {t('timeLeft', { lng: language })}
                </LTItem> */}

                <LTItem maxWidth="60px" minWidth="60px" style={{ textAlign: 'center' }}>
                    {t('actions', { lng: language })}
                </LTItem>
            </LTHeader>
            {appsWithOffers.length === 0 && (
                <LTPlaceholder> {t('theListIsEmpty', { lng: language })}</LTPlaceholder>
            )}
            {appsWithOffers.map((app: Application, i) => (
                <CustomLTRow key={i} id={i.toString()} onClick={() => linkToAgreement(app.id)}>
                    {/*FULL SCREEN VERSION*/}
                    <LTItem maxWidth="40%" minWidth="40%">
                        {app.program_name}
                    </LTItem>
                    <LTItem maxWidth="60px" minWidth="60px" style={{ textAlign: 'center' }}>
                        {app?.value
                            ? `${convertToCurrencySymbol(app?.currency ? app?.currency : '')} ${app.value}`
                            : `${convertToCurrencySymbol(app?.currency ? app?.currency : '')} 0`}
                    </LTItem>
                    {/* {app.date_agreement_signed ? (
                                <LTItem
                                    style={{ textAlign: 'center' }}
                                    maxWidth="100px"
                                    minWidth="100px">
                                    {t('accepted', { lng: language })}
                                </LTItem>
                            ) : (
                                <LTItem
                                    maxWidth="100px"
                                    minWidth="100px"
                                    style={{ textAlign: 'center' }}>
                                    {app.date_offer_sent ? (
                                        getDeadline(app.date_offer_sent) > 0 ? (
                                            <DeadlineTimer
                                                deadline={getDeadline(app.date_offer_sent)}
                                            />
                                        ) : (
                                            `${t('expired', { lng: language })}`
                                        )
                                    ) : (
                                        '--'
                                    )}
                                </LTItem>
                            )} */}
                    <LTItem maxWidth="60px" minWidth="60px">
                        <div
                            style={{
                                display: 'flex',
                                gap: '0.5rem',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {app.date_agreement_signed ? (
                                <div>--</div>
                            ) : (
                                <S.FakeLink
                                    style={{ textAlign: 'center' }}
                                    onClick={() => linkToAgreement(app.id)}
                                >
                                    {t('sign', { lng: language })}
                                </S.FakeLink>
                            )}
                        </div>
                    </LTItem>

                    {/*SMALL SCREEN VERSION*/}
                    <LTMobileItem name={t('visaName', { lng: language })}>
                        {app.program_name}
                    </LTMobileItem>
                    <LTMobileItem
                        name={t('amount', {
                            lng: language,
                        })}
                    >{`${convertToCurrencySymbol(app?.currency ? app?.currency : '')} ${app.value}`}</LTMobileItem>

                    {/* {app.date_agreement_signed ? (
                                <LTMobileItem name={t('timeLeft', { lng: language })}>
                                    {t('accepted', { lng: language })}
                                </LTMobileItem>
                            ) : (
                                <LTMobileItem name={t('timeLeft', { lng: language })}>
                                    {app.date_offer_sent ? (
                                        getDeadline(app.date_offer_sent) > 0 ? (
                                            <DeadlineTimer
                                                deadline={getDeadline(app.date_offer_sent)}
                                            />
                                        ) : (
                                            `${t('expired', { lng: language })}`
                                        )
                                    ) : (
                                        '--'
                                    )}
                                </LTMobileItem>
                            )} */}

                    <LTMobileItem name={t('actions', { lng: language })}>
                        {app.date_agreement_signed ? (
                            <div>--</div>
                        ) : (
                            <S.FakeLink onClick={() => linkToAgreement(app.id)}>
                                {t('sign', { lng: language })}
                            </S.FakeLink>
                        )}
                    </LTMobileItem>
                </CustomLTRow>
            ))}
        </S.ListTable>
    );
}

export default VisaOffersB2B;
